 
 
 
 
 
 
define([], function() {
    'use strict';
    return {
        /**
        * This method tries to mitigate a bug causing background bleeding near tiles edges.
        * More info can be found here: LNS-9557
        * When this issue is fixed in Leaflet itself this method may be removed.
        */
        fixTileScale: function() {
            this.on('tileloadstart', function(event) {
                event.tile.style.transform += ' scale(1.002)';
            });
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/tileSetTransform.js